<div [hidden]="!displayInput">
	<ng-select #inputField
		style="border-radius: 50%;"
		[items]="results$ | async"
		bindLabel="name" 
		[addTag]="false"
		[multiple]="false"
		[hideSelected]="true"
		[loading]="results$Loading"
		[typeahead]="searchTerm$"
		placeholder="Search by railcar, lease or customer..." 
		(change)="itemSelected($event)"
		[virtualScroll]="false"
		class="ng-select-sm custom rounded">
		<ng-template ng-label-tmp let-item="item">
			<i class="fa" 
				[ngClass]="{'fa-user-circle': item.type === 'Customer',
							'rail360-danger': item.type === 'Customer',
							'fa-handshake': item.type === 'Lease',
							'rail360-primary': item.type === 'Lease',
							'fa-train': item.type === 'Railcar'}"></i> {{item.name}}
		</ng-template>
		<ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
			<i class="fa" 
				[ngClass]="{'fa-user-circle': item.type === 'Customer',
							'rail360-danger': item.type === 'Customer',
							'fa-handshake': item.type === 'Lease',
							'rail360-primary': item.type === 'Lease',
							'fa-train': item.type === 'Railcar'}"></i> {{item.name}}
		</ng-template>
	</ng-select>
</div>